import React, { FormEvent, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../Components/Button/Button';
import CheckBox from '../../Components/CheckBox/CheckBox';
import Input from '../../Components/Input/Input';
import { Context } from '../../Context/Context';
import { types } from '../../Context/Reducers/Reducer';
import { Event } from '../../Interfaces/Event';
import toast from '../../utils/helpers';
import styles from './AddAddress.module.scss';

const AddAddress = () => {
  const history = useHistory();
  const { dispatch } = useContext(Context);
  const INITIAL_ADDRESS = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    email: '',
    state: '',
    phone: '',
    pin: '',
  };
  const [address, setAddress] = useState(INITIAL_ADDRESS);
  const [isDefaultAddress, setIsDefaultAddress] = useState(false);
  const [errors, setErrors] = useState();
  const handleChange = (e: Event) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };
  const toggleCheckBox = () => {
    setIsDefaultAddress(!isDefaultAddress);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    const {
      firstName,
      lastName,
      address1,
      email,
      state,
      phone,
      pin,
    } = address;
    if (errors || firstName === '' || lastName === ''
      || address1 === '' || email === '' || state === ''
      || phone === '' || pin === '') {
      toast('Please input valid data');
      return;
    }
    e.preventDefault();
    dispatch({ type: types.ADD_ADDRESS, payload: { address, defaultAddress: isDefaultAddress } });
    setAddress(INITIAL_ADDRESS);
    setIsDefaultAddress(false);
    toast('Address added successfully!');
    // history.push('/address');
    history.goBack();
  };
  const handleErrors = (error: any) => {
    setErrors(error);
  };

  return (
    <div className={styles.addressContainer}>
      <div className={styles.title}>Deliver To</div>
      <form className={styles.form} onSubmit={handleSubmit} autoComplete="off">
        <div className={styles.inputContainer}>
          <div className={styles.column}>
            <Input
              type="text"
              label="First Name"
              name="firstName"
              onChange={handleChange}
              value={address.firstName}
              handleError={handleErrors}
            />
            <Input
              type="text"
              label="Last Name"
              name="lastName"
              onChange={handleChange}
              value={address.lastName}
              handleError={handleErrors}
            />
            <Input
              type="email"
              label="Email ID"
              name="email"
              onChange={handleChange}
              value={address.email}
              handleError={handleErrors}
            />
            <Input
              type="number"
              label="Phone Number"
              name="phone"
              onChange={handleChange}
              value={address.phone}
              handleError={handleErrors}
            />
          </div>
          <div className={styles.column}>
            <Input
              type="text"
              label="Address Line 1"
              name="address1"
              onChange={handleChange}
              value={address.address1}
              handleError={handleErrors}
            />
            <Input
              type="text"
              label="Address Line 2"
              name="address2"
              required={false}
              onChange={handleChange}
              value={address.address2}
              handleError={handleErrors}
            />
            <Input
              type="number"
              label="Pin Code"
              name="pin"
              onChange={handleChange}
              value={address.pin}
              handleError={handleErrors}
            />
            <Input
              type="text"
              enableDropdown
              label="State"
              name="state"
              onChange={handleChange}
              handleError={handleErrors}
            />
          </div>
        </div>
        <div className={styles.defaultAddress}>
          <CheckBox isChecked={isDefaultAddress} toggle={toggleCheckBox} />
          <div onClick={toggleCheckBox} className={styles.cursor} aria-hidden>
            Select as default address
          </div>
        </div>
        <div className={styles.button}>
          <Button width="15vw" onClick={handleSubmit} disabled={!!errors}>Submit</Button>
        </div>
      </form>
    </div>
  );
};

export default AddAddress;
